import { Box, Typography } from "@mui/material"

const FilmFestivalHeader = () => {
  return <Box>{/* <Typography variant="h6">Film Festival Header</Typography> */}</Box>
}

export default FilmFestivalHeader
